import React from "react";
import ContentBox from "../../Box/ContentBox/ContentBox";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Typography from "@mui/material/Typography";


export const StatusBoxDeactivatedProduct = () => {
  return (
    <ContentBox icon={InfoOutlinedIcon} headline={"Produkt nicht mehr unterstützt"} alignContent={"stretch"}>
      <Typography sx={{
        textAlign: "center"
      }}>Dieses Produkt wird von uns nicht mehr angeboten. Bisher erhaltene Dokumente können sie im Bereich “Meine Dokumente” weiterhin abrufen.</Typography>
    </ContentBox>
  );
};
